import tractors from '../predictor/data/production/brands/tractors.json';

export default tractors;
